module.exports = __webpack_public_path__ + "media/images/podpis-2162b5bc.jpg";